// extracted by mini-css-extract-plugin
module.exports = {"liveTag":"LiveTag_liveTag_1tZ2nzp","fade":"LiveTag_fade_3W0RnhF"};